export default {
  landmarkList: [],
  isLandmarkTableLoading: false,
  landmarkKeyword: '',
  paging: {
    currentPage: 1,
    nextPage: null,
    previousPage: null,
    totalPages: 1,
    perPage: 25,
    totalEntries: null,
  },
}



// WEBPACK FOOTER //
// ./src/store/landmark/state.js